import { useIntl } from 'react-intl';
import { mapDescriptionSize, mapDescriptionColor } from './helpers';

const Description = ({ message, size = 14, color = 'black' }) => {
  const { formatMessage } = useIntl();
  const classNames = `integration__description ${mapDescriptionSize[size]} ${mapDescriptionColor[color]}`;

  return (
    <p className={classNames}>
      {message
        ? formatMessage(
            {
              id: message,
            },
            {
              br: <br />,
            }
          )
        : message}
    </p>
  );
};

export default Description;
